<template>
    <div id="CartToast" class="shadow-heavy" :class="{active: getShowToast}" @click="toggleCart()">
        <div class="head">
            <p><i class="fal fa-check-circle"></i>Added to cart</p>
            <button class="btn btn-sqr" @click.stop="setShowToast(false)"><i class="fal fa-times"></i></button>
        </div>
        <hr>
        <div class="body" v-if="getToastProduct">
            <div class="product">
                <ul>
                    <li class="image" v-if="getToastProduct.Image && getToastProduct.Image.ID">
                        <img :src="getToastProduct.Image.URL"/>
                    </li>
                    <li class="quantity vertical-middle">
                        <div>
                            <p>{{ getToastProduct.Quantity }}x</p>
                        </div>
                    </li>
                    <li class="name vertical-middle">
                        <div>
                            <p v-if="getToastVariation">{{ getToastVariation.Title }}</p>
                            <p v-else>{{ getToastProduct.Title }}</p>
                        </div>
                    </li>
                    <li class="price vertical-middle">
                        <div>
                            <template v-if="getToastVariation && getToastVariation.LocalisedPrice > 0">
                                <p class="sub" :class="{slashed: getToastVariation.DiscountedPrice !== getToastVariation.LocalisedPrice}">
                                    ${{ getToastVariation.LocalisedPrice.toFixed(2) }}</p>
                                <p class="sub" v-if="getToastVariation.DiscountedPrice !== getToastVariation.LocalisedPrice">
                                    ${{ getToastVariation.DiscountedPrice.toFixed(2) }}</p>
                            </template>
                            <template v-else-if="getToastProduct.LocalisedPrice > 0">
                                <p class="sub" :class="{slashed: getToastProduct.DiscountedPrice !== getToastProduct.LocalisedPrice}">
                                    ${{ getToastProduct.LocalisedPrice.toFixed(2) }}</p>
                                <p class="sub" v-if="getToastProduct.DiscountedPrice !== getToastProduct.LocalisedPrice">
                                    ${{ getToastProduct.DiscountedPrice.toFixed(2) }}</p>
                            </template>
                        </div>
                    </li>
                    <li class="bin vertical-middle"></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "CartButton",
    computed: {
        ...mapGetters(['getShowToast', 'getToastProduct', 'getToastVariation'])
    },
    methods: {
        ...mapActions(['setShowToast', 'toggleShowCart']),
        toggleCart() {
            this.setShowToast(false);
            this.toggleShowCart();
        }
    },
}
</script>
